export enum WrittenContent {
  BlogPosts = 'blog_posts',
  Articles = 'articles',
  WebsiteCopy = 'website_copy',
  SocialMediaPosts = 'social_media_posts',
  Newsletters = 'newsletters'
}

export enum AudioContent {
  ScriptsForPodcasts = 'scripts_for_podcasts',
  ScriptsForVoiceovers = 'scripts_for_voiceovers',
  ScriptsForExplainerVideos = 'scripts_for_explainer_videos',
  ScriptsForTutorials = 'scripts_for_tutorials',
  ScriptsForWebinars = 'scripts_for_webinars'
}

export enum InteractiveContent {
  QuestionsForSurveys = 'questions_for_surveys',
  IdeasForInfographics = 'ideas_for_infographics',
  ConceptsForWeb = 'concepts_for_web',
  ScriptsForVideos = 'scripts_for_videos'
}

export enum Presentations {
  TextForSalesDecks = 'text_for_sales_decks',
  TextForPitchDecks = 'text_for_pitch_decks',
  TextForSlidePresentations = 'text_for_slide_presentations'
}

export enum ContentRepurposing {
  TransformingBlogPosts = 'transforming_blog_posts',
  SummarizingArticles = 'summarizing_articles',
  ConvertingWebinars = 'converting_webinars'
}

export type ContentFormat =
  | WrittenContent
  | AudioContent
  | InteractiveContent
  | Presentations
  | ContentRepurposing;
